<template>
  <main>
    <wo-region>
      <wo-layout>
        <po-route-breadcrumb />
      </wo-layout>
    </wo-region>
    <router-view />
  </main>
</template>

<script>

export default {}
</script>
